import { Card, CardContent, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
  },
  section: {
    marginTop: theme.spacing(2),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
  },
  valueBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
})

const InfoCard = ({
  name,
  requests,
  value,
}: {
  name: string
  requests: number
  value: number
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          variant='h6'
          fontWeight='bold'
          gutterBottom
          color={Colors.TEXT_COLOR_MAIN}
        >
          {name}
        </Typography>
        <Box className={classes?.section}>
          <Typography className={classes?.label}>No. Of Requests</Typography>
          <div className={classes?.valueBox}>{requests}</div>
        </Box>
        <Box className={classes?.section}>
          <Typography className={classes?.label}>Value</Typography>
          <div className={classes?.valueBox}>₹{value}</div>
        </Box>
      </CardContent>
    </Card>
  )
}

export default InfoCard
